// Used before applying CSS transition
export default function forceReflow(element: HTMLElement) {
  element.offsetWidth;
}
